import { Reveal } from "@/components/common/Reveal";
import { CtaLink } from "@/components/common/Cta";
import { CONTACT } from "@/data/site";

export const CtaBand = ({ title = "Partner on your next scheme", testid = "cta-band" }) => (
  <section className="relative overflow-hidden bg-brand text-canvas" data-testid={testid}>
    <div className="absolute inset-0 cad-grid-light opacity-60" aria-hidden />
    <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-28">
      <Reveal>
        <p className="label-mono">Tender · Programme · Handover</p>
        <h2 className="mt-6 max-w-4xl font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl">{title}</h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-canvas/85 sm:text-lg">
          Send us the scheme details and our team will come back to you to talk through scope, programme and pricing.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
          <CtaLink to="/contact" variant="dark" testid={`${testid}-enquiry-btn`}>Send a project enquiry</CtaLink>
          <a href={`tel:${CONTACT.phones[0].tel}`} className="font-display text-xl font-semibold uppercase tracking-wide underline-offset-4 hover:underline" data-testid={`${testid}-phone`}>
            or call {CONTACT.phones[0].value}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
